import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { Reveal } from './Reveal';

const panels = [
  {
    src: new URL('../assets/hb-1.png', import.meta.url).href,
    alt: 'See the dollars — every open care gap connects to its specific dollar impact, priced continuously as the year runs.',
  },
  {
    src: new URL('../assets/hb-2.png', import.meta.url).href,
    alt: 'Survive the audit — MEAT-bound, RADV-survivable numbers backed by defensible documentation.',
  },
  {
    src: new URL('../assets/hb-3.png', import.meta.url).href,
    alt: 'Act before the cliff — take action before the measurement year closes and the window to change the outcome is gone.',
  },
];


export function HealthBridgeTeaser() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <Reveal as="div" direction="right" className="space-y-6">
            <span className="border-l-4 border-[#34AFFB] pl-3 text-[#34AFFB] text-sm font-semibold inline-block">
              Our Solution
            </span>
            <h2 className="text-4xl text-[#1f2937]">
              HealthBridge: the financial intelligence layer for value-based care.
            </h2>
            <p className="text-lg text-[#4B5563] leading-relaxed">
              Every unresolved patient gap connects to a specific dollar related to impact. As a representative figure, up to <strong className="text-[#1f2937]">$48M<sup>*</sup></strong> in a quality bonus payment can ride on a single 4.0 Star rating. The window to increase the star rating closes long before the payments are finalized.
            </p>
            <p className="text-[#4B5563]/60" style={{ fontSize: '0.6875rem' }}>
              <sup>*</sup>Representative / projected figure.
            </p>
            <Button asChild className="bg-[#34AFFB] hover:bg-[#34AFFB]/90 text-white">
              <Link to="/healthbridge">
                Explore HealthBridge
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </Reveal>

          {/* Right — the three-part hook, illustrated */}
          <div className="space-y-4">
            {panels.map((panel, index) => (
              <Reveal
                as="img"
                key={panel.src}
                direction="left"
                delay={index * 140}
                src={panel.src}
                alt={panel.alt}
                className="w-full rounded-2xl border border-black/[0.06] shadow-sm"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
